import "./_style.less";
import React, { ReactNode } from "react";
import { Typography } from "antd";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { VuiButton } from "../../../@vendor/components";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useWindowSize } from "usehooks-ts";

export interface FloatingBookingStepProps {
  previewContent: ReactNode;
  onBack?: () => void;
  onNext?: () => void;
  isLastItem?: boolean;
  isFirstItem?: boolean;
}

export interface FloatingBookingStepItemProps {
  label: string;
  value: number;
  currentStep: number;
  total: number;
}

const FloatingBookingStep: React.FC<FloatingBookingStepProps> = ({
  previewContent,
  onBack,
  onNext,
  isLastItem,
  isFirstItem,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="floating-booking-step-summary">
        <div className="floating-booking-summary-container">
          <div className="floating-booking-summary-action-wrapper">
            {!isFirstItem && (
              <>
                <div
                  onClick={onBack}
                  className="floating-booking-summary-action-icon"
                >
                  <LeftOutlined />
                </div>

                <VuiButton
                  buttonProps={{
                    disabled: !onBack,
                    onClick: onBack,
                    className: "action-btn back",
                    type: "default",
                  }}
                  label={t("common.button.back")}
                />
              </>
            )}

            <div className="floating-booking-summary-preview">
              {previewContent}
            </div>

            {!isLastItem && (
              <div>
                <div
                  onClick={onNext}
                  className="floating-booking-summary-action-icon"
                >
                  <RightOutlined />
                </div>

                <VuiButton
                  buttonProps={{
                    disabled: !onNext,
                    onClick: onNext,
                    className: "action-btn",
                    type: "primary",
                  }}
                  label={t("common.button.next")}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const FloatingBookingStepItem: React.FC<FloatingBookingStepItemProps> = ({
  label,
  currentStep,
  value,
  total,
}) => {
  const { width } = useWindowSize();
  const isMobile = width < 768;

  return (
    <div
      className={clsx("floating-booking-step-item text-center", {
        "is-active": currentStep === value,
        finished: currentStep > value,
      })}
    >
      <Typography.Text className="floating-booking-step-item-text">
        {isMobile
          ? `${label} (${value + 1}/${total})`
          : `Step ${value + 1} (${label})`}
      </Typography.Text>
      <div className="floating-booking-step-item-border"></div>
    </div>
  );
};

export { FloatingBookingStep, FloatingBookingStepItem };
